import { defaultLocale } from '@chilipiper/locale'

const timeFormats: { [locale: string]: { [format: string]: string } } = {
  en_US: {
    a: 'a',
    'DD.MM.YYYY': 'DD.MM.YYYY',
    'DD/MM/YYYY': 'DD/MM/YYYY',
    'DD-MM-YYYY': 'DD-MM-YYYY',
    ddd: 'ddd',
    'ddd, MMM DD': 'ddd, MMM DD',
    dddd: 'dddd',
    'dddd, MMM Do': 'dddd, MMM Do',
    'dddd, MMM Do | h:mmA': 'dddd, MMM Do | h:mmA',
    'dddd, MMM Do YYYY': 'dddd, MMM Do YYYY',
    'Do of MMMM YYYY': 'Do of MMMM YYYY',
    'h:mm A': 'h:mm A',
    'h:mm:ss': 'h:mm:ss',
    'h:mmA': 'h:mmA',
    'h:mmA z': 'h:mmA z',
    l: 'l',
    llll: 'llll',
    LT: 'LT', // 1:42 PM
    'LT condensed': 'h:mmA', // 1:42PM (no space)
    'LT z': 'LT z', // 1:42 PM EEST
    MMM: 'MMM',
    'MMM Do': 'MMM Do',
    'MMM Do, YYYY': 'MMM Do, YYYY',
    'MMM DD YYYY': 'MMM DD YYYY',
    'MMM DD YYYY   hh:mm A': 'MMM DD YYYY   hh:mm A',
    'MMMM Do YYYY': 'MMMM Do YYYY',
    'YYYY-MM-DD': 'YYYY-MM-DD',
    z: 'z',
  },
  /*
    'ru_RU': {
        'dddd, MMM Do': 'dddd, D MMM',
        'dddd, MMM Do YYYY': 'dddd, ll',
    }
*/
} as const

export const getDateTimeFormat: (locale: string) => (format: string) => string = locale => {
  const timeFormat = timeFormats[locale] || timeFormats[defaultLocale]

  return format => timeFormat[format]
}
